import {
    Button,
    Modal,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "@heroui/react";
import { ThemedText } from "@/components/ui";

const DeleteConfirmModal = ({
    table,
    title = "Konfirmasi Hapus",
    description = "Apakah Anda yakin ingin menghapus data ini? Tindakan ini tidak dapat dibatalkan.",
}) => {
    const { deleteState } = table;

    return (
        <Modal
            isOpen={deleteState.isOpen}
            onOpenChange={deleteState.onOpenChange}
            classNames={{
                header: "border-b border-default-100",
                footer: "border-t border-default-100",
            }}
        >
            <ModalContent>
                {(handleClose) => (
                    <>
                        <ModalHeader className="flex flex-col gap-1">
                            <ThemedText className="font-semibold">
                                {title}
                            </ThemedText>
                        </ModalHeader>
                        <ModalBody className="py-4">
                            <ThemedText size="sm" variant="secondary">
                                {description}
                            </ThemedText>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="danger"
                                variant="light"
                                onPress={handleClose}
                                size="sm"
                            >
                                Batal
                            </Button>
                            <Button
                                color="primary"
                                onPress={deleteState.confirmDelete}
                                isLoading={deleteState.isDeleting}
                                size="sm"
                            >
                                Hapus
                            </Button>
                        </ModalFooter>
                    </>
                )}
            </ModalContent>
        </Modal>
    );
};

export default DeleteConfirmModal;
